import { Promocao } from '../shared/entity/Promocao';
import { FindManyReq, FindOneReq } from '../shared/types/TypeormTypes';
import api from './api';
import Categoria from '../shared/entity/Categoria';
import { GetOneParams } from '../shared/types/TypeormTypes';

const BASE_URL = '/promocao';

class promocaoApi {
  async getOne(query: GetOneParams<Promocao>) {
    try {
      let res = await this.getMany({ ...query, take: 1 });
      if (!res.length) {
        throw new Error('Promoção não encontrada.');
      }
      return res[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getMany(query: FindManyReq<Promocao>) {
    try {
      let res = await api.post<Promocao[]>(BASE_URL + '/get', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async count(query: FindManyReq<Promocao>) {
    try {
      let res = await api.post<number>(BASE_URL + '/count', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async update(where: Partial<Promocao>, update: Partial<Promocao>) {
    try {
      let res = await api.put(BASE_URL, { update }, { params: where });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async insert(promocao: Partial<Promocao>) {
    try {
      let res = await api.post<Promocao>(BASE_URL, { promocao });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getCardapioPromocao(promocaoId) {
    try {
      let res = await api.get<Categoria[]>(BASE_URL + '/cardapio', {
        params: { promocaoId: promocaoId }
      });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new promocaoApi();
